/**
 * Typed provider gateway adapter registry/assignment API facade.
 */

import { providerGatewayAdaptersApi } from '../api/generated/providerGatewayAdapters.api.js';
import type {
  EfemAdapterAssignmentResponse,
  EfemAdapterRegistryListResponse,
  LocationAdapterAssignmentResponse,
  LocationAdapterRegistryListResponse,
  PutEfemAdapterAssignmentBody,
  PutLocationAdapterAssignmentBody,
} from '@cnapse/shared/schemas.js';

class ProviderGatewayAdaptersService {
  async listGatewayAdapterRegistry(
    kind: 'efem' | 'location',
  ): Promise<EfemAdapterRegistryListResponse | LocationAdapterRegistryListResponse> {
    if (kind === 'efem') {
      return providerGatewayAdaptersApi.listEfemRegistry() as Promise<EfemAdapterRegistryListResponse>;
    }
    return providerGatewayAdaptersApi.listLocationRegistry() as Promise<LocationAdapterRegistryListResponse>;
  }

  listEfemAdapterRegistry(): Promise<EfemAdapterRegistryListResponse> {
    return this.listGatewayAdapterRegistry('efem') as Promise<EfemAdapterRegistryListResponse>;
  }

  listLocationAdapterRegistry(): Promise<LocationAdapterRegistryListResponse> {
    return this.listGatewayAdapterRegistry('location') as Promise<LocationAdapterRegistryListResponse>;
  }

  async getGatewayAdapterAssignment(
    kind: 'efem' | 'location',
    serialNumber: string,
  ): Promise<EfemAdapterAssignmentResponse | LocationAdapterAssignmentResponse> {
    if (kind === 'efem') {
      return providerGatewayAdaptersApi.getEfemAssignment(serialNumber) as Promise<EfemAdapterAssignmentResponse>;
    }
    return providerGatewayAdaptersApi.getLocationAssignment(serialNumber) as Promise<LocationAdapterAssignmentResponse>;
  }

  async putGatewayAdapterAssignment(
    kind: 'efem' | 'location',
    serialNumber: string,
    body: PutEfemAdapterAssignmentBody | PutLocationAdapterAssignmentBody,
  ): Promise<EfemAdapterAssignmentResponse | LocationAdapterAssignmentResponse> {
    if (kind === 'efem') {
      return providerGatewayAdaptersApi.putEfemAssignment(
        serialNumber,
        body as PutEfemAdapterAssignmentBody,
      ) as Promise<EfemAdapterAssignmentResponse>;
    }
    return providerGatewayAdaptersApi.putLocationAssignment(
      serialNumber,
      body as PutLocationAdapterAssignmentBody,
    ) as Promise<LocationAdapterAssignmentResponse>;
  }

  putEfemAdapterAssignment(
    serialNumber: string,
    body: PutEfemAdapterAssignmentBody,
  ): Promise<EfemAdapterAssignmentResponse> {
    return this.putGatewayAdapterAssignment('efem', serialNumber, body) as Promise<EfemAdapterAssignmentResponse>;
  }

  putLocationAdapterAssignment(
    serialNumber: string,
    body: PutLocationAdapterAssignmentBody,
  ): Promise<LocationAdapterAssignmentResponse> {
    return this.putGatewayAdapterAssignment('location', serialNumber, body) as Promise<LocationAdapterAssignmentResponse>;
  }
}

export const providerGatewayAdaptersService = new ProviderGatewayAdaptersService();
